import {LOOKUP_ENUM} from "../../dictionary/core/lookup.enum";
export const ORDER_SERVICE_STATUS = LOOKUP_ENUM.ORDER_SERVICE_STATUS;
